import $ from 'jquery';
import throttle from 'lodash.throttle';
import { libNodes } from '../utils/Utils';

const $headerTop = $('.header__top');
const $headerBottom = $('.header__bottom');
const $headerMobile = $('.header__mobile');

let headerMobileHeight = $headerMobile.innerHeight();
const triggerScrollOffset = 20;
const scrollTopHeaderHide = 300;
let currentScrollPosition = window.pageYOffset;
let lastScrollPosition = window.pageYOffset;

const onScroll = () => {
    if (window.innerWidth > 911) {
        if (window.pageYOffset > parseInt(libNodes.$html.css('--header_top_height'))) {
            $headerBottom.addClass('header__bottom--fixed');
            $headerTop.css({
                'margin-bottom': libNodes.$html.css('--header_bottom_height')
            });
        } else {
            $headerBottom.removeClass('header__bottom--fixed');
            $headerTop.css({
                'margin-bottom': ''
            });
        }
    } else {
        if (window.pageYOffset > 0) {
            currentScrollPosition = window.pageYOffset;

            $headerMobile.addClass('header__mobile--fixed');

            libNodes.$main.css({
                'margin-top': `${headerMobileHeight}px`
            });

            if (Math.abs(currentScrollPosition - lastScrollPosition) < triggerScrollOffset) {
                return;
            }

            if (window.pageYOffset > scrollTopHeaderHide) {
                $headerMobile.addClass('header__mobile--hidden');

                if (currentScrollPosition > lastScrollPosition) {
                    $headerMobile.addClass('header__mobile--hidden').removeClass('header__mobile--showed');
                } else {
                    $headerMobile.addClass('header__mobile--showed').removeClass('header__mobile--hidden');
                }
            }

            lastScrollPosition = currentScrollPosition;
        } else {
            $headerMobile.removeClass(['header__mobile--fixed', 'header__mobile--hidden']);

            libNodes.$main.css({
                'margin-top': ''
            });
        }
    }
};

const init = () => {
    window.addEventListener('scroll', throttle(onScroll, 100));
};

export default init();
